import React from 'react';
import Button from '../../../components/ui/Button';
import Icon from '../../../components/AppIcon';

const HeroSection = () => {
  return (
    <section className="relative bg-gradient-to-br from-[var(--color-primary)] via-[var(--color-brand-primary)] to-[var(--color-secondary)] text-white overflow-hidden">
      <div className="absolute inset-0 opacity-10">
        <div className="absolute top-20 left-10 w-64 h-64 bg-white rounded-full blur-3xl"></div>
        <div className="absolute bottom-20 right-10 w-96 h-96 bg-white rounded-full blur-3xl"></div>
      </div>
      
      <div className="relative max-w-7xl mx-auto px-4 md:px-6 lg:px-8 py-16 md:py-24 lg:py-32">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-12 items-center">
          <div className="text-center lg:text-left">
            <div className="inline-flex items-center gap-2 bg-white/10 backdrop-blur-sm px-4 py-2 rounded-full mb-6 md:mb-8">
              <Icon name="Shield" size={16} color="#FFFFFF" />
              <span className="text-xs md:text-sm font-medium">Bank-Level Security • FDIC Insured</span>
            </div>
            
            <h1 className="text-3xl md:text-4xl lg:text-5xl xl:text-6xl font-bold mb-4 md:mb-6 leading-tight">
              Your Digital Vault for Financial Freedom
            </h1>
            
            <p className="text-base md:text-lg lg:text-xl text-white/90 mb-6 md:mb-8 max-w-2xl mx-auto lg:mx-0">
              Your secure gateway to cryptocurrency investing. Experience institutional-grade security with user-friendly onboarding designed for both newcomers and experienced investors.
            </p>
            
            <div className="flex flex-col sm:flex-row gap-4 justify-center lg:justify-start">
              <Button 
                variant="default" 
                size="lg"
                iconName="ArrowRight"
                iconPosition="right"
                className="bg-white text-[var(--color-primary)] hover:bg-white/90"
                onClick={() => window.location.href = '/registration'}
              >
                Get Started Free
              </Button>
              <Button 
                variant="outline" 
                size="lg"
                iconName="PlayCircle"
                iconPosition="left"
                className="border-white text-white hover:bg-white/10"
              >
                Watch Demo
              </Button>
            </div>
            
            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-4 md:gap-6 mt-8 md:mt-12">
              <div className="flex items-center gap-2">
                <Icon name="Users" size={20} color="#FFFFFF" />
                <span className="text-sm md:text-base">500K+ Active Users</span>
              </div>
              <div className="flex items-center gap-2">
                <Icon name="TrendingUp" size={20} color="#FFFFFF" />
                <span className="text-sm md:text-base">$2.5B+ Traded</span>
              </div>
              <div className="flex items-center gap-2">
                <Icon name="Star" size={20} color="#FFFFFF" />
                <span className="text-sm md:text-base">4.8/5 Rating</span>
              </div>
            </div>
          </div>
          
          <div className="relative hidden lg:block">
            <div className="relative bg-white/10 backdrop-blur-lg rounded-2xl p-6 border border-white/20">
              <div className="space-y-4">
                <div className="flex items-center justify-between p-4 bg-white/10 rounded-lg">
                  <div className="flex items-center gap-3">
                    <div className="w-10 h-10 bg-[var(--color-accent)] rounded-full flex items-center justify-center">
                      <Icon name="Bitcoin" size={24} color="#FFFFFF" />
                    </div>
                    <div>
                      <p className="font-semibold">Bitcoin</p>
                      <p className="text-sm text-white/70">BTC</p>
                    </div>
                  </div>
                  <div className="text-right">
                    <p className="font-bold text-lg">$42,856.32</p>
                    <p className="text-sm text-green-400">+2.45%</p>
                  </div>
                </div>
                
                <div className="flex items-center justify-between p-4 bg-white/10 rounded-lg">
                  <div className="flex items-center gap-3">
                    <div className="w-10 h-10 bg-[var(--color-brand-primary)] rounded-full flex items-center justify-center">
                      <Icon name="Coins" size={24} color="#FFFFFF" />
                    </div>
                    <div>
                      <p className="font-semibold">Ethereum</p>
                      <p className="text-sm text-white/70">ETH</p>
                    </div>
                  </div>
                  <div className="text-right">
                    <p className="font-bold text-lg">$2,234.18</p>
                    <p className="text-sm text-green-400">+1.82%</p>
                  </div>
                </div>
                
                <div className="flex items-center justify-between p-4 bg-white/10 rounded-lg">
                  <div className="flex items-center gap-3">
                    <div className="w-10 h-10 bg-[var(--color-secondary)] rounded-full flex items-center justify-center">
                      <Icon name="DollarSign" size={24} color="#FFFFFF" />
                    </div>
                    <div>
                      <p className="font-semibold">Cardano</p>
                      <p className="text-sm text-white/70">ADA</p>
                    </div>
                  </div>
                  <div className="text-right">
                    <p className="font-bold text-lg">$0.5847</p>
                    <p className="text-sm text-red-400">-0.34%</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;